const StickyRightIcon = ({ viewBox = "0 0 32 32", className = "hayley-h-8 hayley-w-8" }) => {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.0121 20.7821C23.0121 20.7821 25.9815 20.7423 27.1859 20.0666C28.2137 19.4897 29.0309 18.7516 28.8597 17.5483C28.8597 17.5483 27.8934 18.4905 26.8531 18.2915C24.2349 17.7908 22.8411 19.5794 23.0121 20.7821Z"
        fill="url(#paint0_radial_776_11897)"
      />
      <path
        d="M23.6858 18.8707C23.6858 18.8707 27.1357 18.8247 28.5345 18.0394C29.7289 17.369 30.6783 16.5114 30.4795 15.1138C30.4795 15.1138 29.3567 16.2084 28.1481 15.9772C25.1064 15.3953 23.4872 17.4732 23.6858 18.8707Z"
        fill="url(#paint1_radial_776_11897)"
      />
      <path
        d="M23.8839 17.7381C23.8839 17.7381 28.1569 17.251 29.8106 16.1027C31.2221 15.1225 32.3107 13.9408 31.9197 12.2324C31.9197 12.2324 30.6407 13.7297 29.118 13.5937C25.286 13.2515 23.4931 16.0299 23.8839 17.7381Z"
        fill="url(#paint2_radial_776_11897)"
      />
      <path
        d="M8.9884 20.4007C8.9884 20.4007 6.01919 20.3611 4.8148 19.6853C3.78681 19.1083 2.9695 18.3701 3.14069 17.167C3.14069 17.167 4.10716 18.1092 5.14765 17.9102C7.76578 17.4094 9.15952 19.1981 8.9884 20.4007Z"
        fill="url(#paint3_radial_776_11897)"
      />
      <path
        d="M8.31501 18.4894C8.31501 18.4894 4.86533 18.4432 3.46625 17.658C2.2719 16.9876 1.32248 16.1301 1.52131 14.7324C1.52131 14.7324 2.64403 15.827 3.85269 15.5959C6.89452 15.014 8.51384 17.0919 8.31501 18.4894Z"
        fill="url(#paint4_radial_776_11897)"
      />
      <path
        d="M8.11623 17.3572C8.11623 17.3572 3.84329 16.8701 2.18952 15.7219C0.777955 14.7417 -0.310656 13.5599 0.080421 11.8516C0.080421 11.8516 1.35939 13.3489 2.88209 13.2128C6.71449 12.8706 8.50731 15.649 8.11623 17.3572Z"
        fill="url(#paint5_radial_776_11897)"
      />
      <path
        d="M22.1411 1.89595C22.1411 0.0526115 16.9305 0 16.3366 0C15.7429 0 10.5322 0.0526884 10.5322 1.89595C10.5322 2.11295 10.6051 2.30568 10.7328 2.4753C10.9141 2.71548 11.2077 2.91252 11.5675 3.07259C13.1186 3.76464 15.9117 3.79206 16.3366 3.79206C16.7636 3.79206 19.5784 3.76471 21.1261 3.0642C21.4773 2.90521 21.7632 2.71132 21.9406 2.4753C22.0691 2.30575 22.1411 2.11302 22.1411 1.89595ZM21.0935 1.87069C21.105 1.87908 21.1165 1.88756 21.1261 1.89595C20.7405 2.22148 19.1094 2.73859 16.3366 2.73859C13.6101 2.73859 11.9876 2.23828 11.5675 1.91174C11.5607 1.90651 11.5541 1.90119 11.5473 1.89595C11.5569 1.88756 11.5684 1.87908 11.5799 1.87069C12.0183 1.54415 13.636 1.05332 16.3366 1.05332C19.0374 1.05332 20.655 1.54415 21.0935 1.87069Z"
        fill="url(#paint6_linear_776_11897)"
      />
      <path
        d="M21.1369 3.05947C21.5894 2.8528 21.6023 2.15259 21.1627 1.9148C21.1383 1.90163 21.1249 1.89485 21.1263 1.89616C20.7407 2.22169 19.1096 2.7388 16.3369 2.7388C13.6104 2.7388 11.9879 2.23848 11.5677 1.91195C11.561 1.90671 11.5543 1.9014 11.5476 1.89616C11.549 1.89485 11.5359 1.90147 11.5121 1.91434C11.071 2.15275 11.0865 2.85419 11.5408 3.06071C11.5497 3.06471 11.5586 3.06872 11.5677 3.07272C13.1189 3.76477 15.9119 3.79219 16.3369 3.79219C16.7639 3.79219 19.5787 3.76484 21.1263 3.06433C21.1299 3.06263 21.1334 3.06109 21.1369 3.05947Z"
        fill="url(#paint7_radial_776_11897)"
      />
      <path
        d="M14.4749 32H12.6007C12.3877 32 12.2148 31.8102 12.2148 31.5763C12.2148 31.3423 12.3877 31.1526 12.6007 31.1526H13.5248C12.6099 25.9679 13.5918 22.9473 13.6353 22.8173C13.7089 22.5977 13.9309 22.4854 14.1308 22.5663C14.3306 22.647 14.433 22.8901 14.3597 23.1096C14.3456 23.1526 13.3529 26.2622 14.3748 31.4873L14.4749 32Z"
        fill="#009BCC"
      />
      <path
        d="M20.0722 31.9996H18.1279L18.2283 31.487C19.2519 26.2513 18.2533 23.1398 18.2431 23.109C18.1704 22.8895 18.2732 22.6462 18.473 22.566C18.6727 22.4858 18.8941 22.5977 18.9675 22.817C19.0113 22.947 19.9929 25.9676 19.0781 31.1523H20.0722C20.2854 31.1523 20.4582 31.3421 20.4582 31.576C20.4582 31.8099 20.2854 31.9996 20.0722 31.9996Z"
        fill="#009BCC"
      />
      <path
        d="M25.4208 24.688C25.4023 24.6916 25.3835 24.6941 25.3644 24.6959C25.173 24.7128 25.0269 24.6243 25.0381 24.4981C25.3095 21.4512 24.0232 19.398 24.0102 19.3776C23.9411 19.2698 24.0304 19.1276 24.2091 19.0599C24.3883 18.9923 24.5889 19.0245 24.658 19.1323C24.7136 19.2187 26.0123 21.2849 25.7316 24.4366C25.7215 24.5502 25.5872 24.6557 25.4208 24.688Z"
        fill="#009BCC"
      />
      <path
        d="M24.6549 24.5812C24.6045 24.04 24.9097 23.544 25.3363 23.4731C25.7631 23.4022 26.1497 23.7835 26.2001 24.3246C26.2503 24.8657 25.9452 25.3617 25.5185 25.4324C25.0918 25.5033 24.7052 25.1222 24.6549 24.5812Z"
        fill="#009BCC"
      />
      <path
        d="M7.60029 24.6437C7.6188 24.6473 7.63756 24.6498 7.65666 24.6516C7.84808 24.6685 7.9942 24.58 7.98296 24.4537C7.71144 21.4069 8.9976 19.3536 9.01057 19.3332C9.07971 19.2254 8.99039 19.0832 8.81162 19.0155C8.63241 18.9479 8.43186 18.9801 8.36272 19.0879C8.30721 19.1743 7.00862 21.2406 7.28949 24.3923C7.29964 24.5059 7.43392 24.6114 7.60029 24.6437Z"
        fill="#009BCC"
      />
      <path
        d="M8.36617 24.5367C8.4165 23.9956 8.11128 23.4996 7.68466 23.4288C7.25789 23.3579 6.87129 23.7392 6.82096 24.2803C6.7708 24.8214 7.07586 25.3173 7.50265 25.3881C7.92927 25.459 8.31594 25.0778 8.36617 24.5367Z"
        fill="#009BCC"
      />
      <path
        d="M24.8908 15.1628C24.8908 19.4927 24.211 23.2961 20.9113 24.9704C20.8173 25.0182 20.7211 25.0648 20.6229 25.1084C19.9023 25.4321 19.0652 25.6617 18.0942 25.7811C17.5869 25.844 17.0425 25.8768 16.4587 25.8776H16.4391C16.4047 25.8776 16.371 25.8768 16.3366 25.876C16.3022 25.8768 16.2686 25.8776 16.2335 25.8776H16.2131C15.6302 25.8768 15.0858 25.844 14.5784 25.7811C13.6074 25.6617 12.7703 25.4321 12.0496 25.1084C11.9515 25.064 11.8553 25.0176 11.7613 24.9698C8.46174 23.2954 7.78174 19.4921 7.78174 15.1628C7.78174 10.0121 10.4556 6.50187 14.4311 5.75128C14.9587 5.65083 15.5087 5.59961 16.0792 5.59961C16.1242 5.59961 16.1681 5.6003 16.2131 5.6003C16.2544 5.60169 16.2951 5.6023 16.3365 5.60369C16.3772 5.6023 16.4179 5.60169 16.4586 5.6003C16.5036 5.6003 16.5485 5.59961 16.5933 5.59961C17.1638 5.59961 17.7139 5.65083 18.2414 5.75128C22.2169 6.50187 24.8908 10.012 24.8908 15.1628Z"
        fill="url(#paint8_radial_776_11897)"
      />
      <path
        d="M22.2714 22.0092L22.2629 22.0343L21.3123 22.2186C21.308 22.4656 21.266 23.9239 20.8498 25.031C20.7952 25.0487 20.7398 25.0658 20.6836 25.082C21.1516 23.8914 21.172 22.2081 21.1727 22.1861V22.1535L22.1417 21.9657C22.2896 21.4553 22.2699 19.4004 22.2692 19.3794L22.4096 19.3789C22.4109 19.467 22.4306 21.5365 22.2714 22.0092Z"
        fill="#ABB1B8"
      />
      <path
        d="M11.4998 22.1861C11.5006 22.2081 11.5209 23.8909 11.9889 25.0816C11.9328 25.0653 11.8773 25.0481 11.8227 25.0306C11.4066 23.9234 11.3644 22.4656 11.3603 22.2186L10.4096 22.0343L10.4012 22.0092C10.2419 21.5365 10.2616 19.467 10.2629 19.3789L10.4032 19.3794C10.4025 19.4004 10.3828 21.4553 10.5309 21.9657L11.4998 22.1535V22.1861Z"
        fill="#ABB1B8"
      />
      <path
        d="M16.4064 5.60352V25.8783H16.2661V5.60352C16.2893 5.60352 16.3131 5.60421 16.3363 5.6049C16.3594 5.60421 16.3833 5.60352 16.4064 5.60352Z"
        fill="#ABB1B8"
      />
      <path
        d="M12.7337 20.5131H19.9393C22.4204 20.5131 24.4946 18.5068 24.8843 15.899C24.8453 14.4174 24.6285 13.0632 24.258 11.8581C23.2066 9.60716 21.069 8.05762 18.6176 8.05762H14.0555C11.6033 8.05762 9.46528 9.60824 8.41413 11.8603C8.04417 13.0644 7.82765 14.4172 7.78857 15.8972C8.17783 18.5059 10.2522 20.5131 12.7337 20.5131Z"
        fill="#ABB1B8"
      />
      <path
        d="M19.9395 19.9107H12.7339C9.97759 19.9107 7.72241 17.4346 7.72241 14.4085C7.72241 10.5841 10.5723 7.45508 14.0557 7.45508H18.6178C22.1011 7.45508 24.9512 10.5841 24.9512 14.4085C24.9511 17.4346 22.696 19.9107 19.9395 19.9107Z"
        fill="url(#paint9_radial_776_11897)"
      />
      <path
        d="M19.6312 19.3777H13.0424C10.5219 19.3777 8.45972 17.1136 8.45972 14.3465C8.45972 10.8495 11.0657 7.98828 14.251 7.98828H18.4227C21.6079 7.98828 24.214 10.8495 24.214 14.3465C24.2139 17.1136 22.1518 19.3777 19.6312 19.3777Z"
        fill="url(#paint10_linear_776_11897)"
      />
      <path
        d="M19.6752 19.3641H12.9972C10.6475 19.3641 8.72485 17.2533 8.72485 14.6734V14.453C8.72485 11.1928 11.1545 8.52539 14.1239 8.52539H18.5484C21.5181 8.52539 23.9474 11.1928 23.9474 14.453V14.6734C23.9475 17.2532 22.0252 19.3641 19.6752 19.3641Z"
        fill="white"
      />
      <path
        d="M20.1327 16.5838C20.3948 16.5838 20.6095 16.4707 20.6095 16.3324C21.0274 14.9967 21.0177 13.6228 20.6095 12.2134C20.6095 12.0751 20.3948 11.9619 20.1327 11.9619C19.8707 11.9619 19.6562 12.0751 19.6562 12.2134V16.3324C19.6562 16.4707 19.8707 16.5838 20.1327 16.5838Z"
        fill="url(#paint11_radial_776_11897)"
      />
      <path
        d="M12.8172 16.5838C12.5554 16.5838 12.3408 16.4708 12.3408 16.3323C11.923 14.9965 11.9326 13.6228 12.3408 12.2136C12.3408 12.075 12.5554 11.9619 12.8172 11.9619C13.0795 11.9619 13.294 12.075 13.294 12.2136V16.3323C13.294 16.4708 13.0795 16.5838 12.8172 16.5838Z"
        fill="url(#paint12_radial_776_11897)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(26.5812 19.5428) rotate(170.271) scale(4.5358 2.25694)"
        >
          <stop stopColor="white" />
          <stop offset="0.1486" stopColor="#F9FDFF" />
          <stop offset="0.2832" stopColor="#EDF7FD" />
          <stop offset="0.4125" stopColor="#D9F0FC" />
          <stop offset="0.5386" stopColor="#BEE5FA" />
          <stop offset="0.6623" stopColor="#99D8F7" />
          <stop offset="0.7842" stopColor="#67CAF3" />
          <stop offset="0.9023" stopColor="#00BCF0" />
          <stop offset="1" stopColor="#00B0ED" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.8322 17.431) rotate(170.271) scale(5.26958 2.62205)"
        >
          <stop stopColor="white" />
          <stop offset="0.1486" stopColor="#F9FDFF" />
          <stop offset="0.2832" stopColor="#EDF7FD" />
          <stop offset="0.4125" stopColor="#D9F0FC" />
          <stop offset="0.5386" stopColor="#BEE5FA" />
          <stop offset="0.6623" stopColor="#99D8F7" />
          <stop offset="0.7842" stopColor="#67CAF3" />
          <stop offset="0.9023" stopColor="#00BCF0" />
          <stop offset="1" stopColor="#00B0ED" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.8772 15.4359) rotate(164.572) scale(6.58572 3.25308)"
        >
          <stop stopColor="white" />
          <stop offset="0.1486" stopColor="#F9FDFF" />
          <stop offset="0.2832" stopColor="#EDF7FD" />
          <stop offset="0.4125" stopColor="#D9F0FC" />
          <stop offset="0.5386" stopColor="#BEE5FA" />
          <stop offset="0.6623" stopColor="#99D8F7" />
          <stop offset="0.7842" stopColor="#67CAF3" />
          <stop offset="0.9023" stopColor="#00BCF0" />
          <stop offset="1" stopColor="#00B0ED" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.41917 19.1615) rotate(9.72865) scale(4.53588 2.25697)"
        >
          <stop stopColor="white" />
          <stop offset="0.1486" stopColor="#F9FDFF" />
          <stop offset="0.2832" stopColor="#EDF7FD" />
          <stop offset="0.4125" stopColor="#D9F0FC" />
          <stop offset="0.5386" stopColor="#BEE5FA" />
          <stop offset="0.6623" stopColor="#99D8F7" />
          <stop offset="0.7842" stopColor="#67CAF3" />
          <stop offset="0.9023" stopColor="#00BCF0" />
          <stop offset="1" stopColor="#00B0ED" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.16846 17.0496) rotate(9.72865) scale(5.26958 2.62205)"
        >
          <stop stopColor="white" />
          <stop offset="0.1486" stopColor="#F9FDFF" />
          <stop offset="0.2832" stopColor="#EDF7FD" />
          <stop offset="0.4125" stopColor="#D9F0FC" />
          <stop offset="0.5386" stopColor="#BEE5FA" />
          <stop offset="0.6623" stopColor="#99D8F7" />
          <stop offset="0.7842" stopColor="#67CAF3" />
          <stop offset="0.9023" stopColor="#00BCF0" />
          <stop offset="1" stopColor="#00B0ED" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.12296 15.055) rotate(15.4283) scale(6.58567 3.25306)"
        >
          <stop stopColor="white" />
          <stop offset="0.1486" stopColor="#F9FDFF" />
          <stop offset="0.2832" stopColor="#EDF7FD" />
          <stop offset="0.4125" stopColor="#D9F0FC" />
          <stop offset="0.5386" stopColor="#BEE5FA" />
          <stop offset="0.6623" stopColor="#99D8F7" />
          <stop offset="0.7842" stopColor="#67CAF3" />
          <stop offset="0.9023" stopColor="#00BCF0" />
          <stop offset="1" stopColor="#00B0ED" />
        </radialGradient>
        <linearGradient id="paint6_linear_776_11897" x1="10.5322" y1="1.896" x2="22.1411" y2="1.896" gradientUnits="userSpaceOnUse">
          <stop offset="0.014" stopColor="#00B0ED" />
          <stop offset="0.1059" stopColor="#77CEF3" />
          <stop offset="0.2637" stopColor="#77CEF3" />
          <stop offset="0.9391" stopColor="#77CEF3" />
          <stop offset="1" stopColor="#00B0ED" />
        </linearGradient>
        <radialGradient
          id="paint7_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.3375 2.84404) scale(3.69035 4.05168)"
        >
          <stop stopColor="#63C9F3" />
          <stop offset="0.5787" stopColor="#00B0ED" />
          <stop offset="0.8316" stopColor="#00AFEB" />
          <stop offset="0.9226" stopColor="#00ABE5" />
          <stop offset="0.9874" stopColor="#00A5DC" />
          <stop offset="1" stopColor="#009BCC" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0962 9.608) scale(12.2987 15.8834)"
        >
          <stop stopColor="#63C9F3" />
          <stop offset="0.4961" stopColor="#00B0ED" />
          <stop offset="0.7732" stopColor="#00AFEB" />
          <stop offset="0.873" stopColor="#00ABE3" />
          <stop offset="0.9439" stopColor="#00A4D9" />
          <stop offset="1" stopColor="#009BCC" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.3368 13.6829) scale(7.29326 8.00736)"
        >
          <stop stopColor="#63C9F3" />
          <stop offset="0.4961" stopColor="#00B0ED" />
          <stop offset="0.7732" stopColor="#00AFEB" />
          <stop offset="0.873" stopColor="#00ABE3" />
          <stop offset="0.9439" stopColor="#00A4D9" />
          <stop offset="1" stopColor="#009BCC" />
        </radialGradient>
        <linearGradient id="paint10_linear_776_11897" x1="16.4858" y1="7.98471" x2="16.3067" y2="14.3205" gradientUnits="userSpaceOnUse">
          <stop offset="5.4e-07" stopColor="#DDDFE3" />
          <stop offset="0.2271" stopColor="#E8E9EB" />
          <stop offset="0.5942" stopColor="#F4F4F5" />
          <stop offset="1" stopColor="#F9F9F9" />
        </linearGradient>
        <radialGradient
          id="paint11_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.2878 14.2729) scale(1.55388 1.70603)"
        >
          <stop stopColor="#00B0ED" />
          <stop offset="0.0849" stopColor="#00ABE5" />
          <stop offset="0.2237" stopColor="#00A3D4" />
          <stop offset="0.3991" stopColor="#2995B9" />
          <stop offset="0.6042" stopColor="#4B7C92" />
          <stop offset="0.8315" stopColor="#47565F" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_776_11897"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.6624 14.2729) scale(1.55388 1.70603)"
        >
          <stop stopColor="#00B0ED" />
          <stop offset="0.0849" stopColor="#00ABE5" />
          <stop offset="0.2237" stopColor="#00A3D4" />
          <stop offset="0.3991" stopColor="#2995B9" />
          <stop offset="0.6042" stopColor="#4B7C92" />
          <stop offset="0.8315" stopColor="#47565F" />
          <stop offset="1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default StickyRightIcon;
